import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getProStatus } from "../../services/proApi";
import "./Pro.css";

// =====================================================
// PRO ROUTE GUARD  (Task 6)
//
// Keeps the Pro screens out of a non-Pro user's way. It asks the SERVER
// whether the membership is active — it never trusts a flag in localStorage —
// and sends anyone without one to the membership page.
//
// This is a usability guard, not the security boundary: the real one is the
// `proOnly` middleware on the server, which refuses a Pro API call regardless
// of what any client does or does not render.
// =====================================================
function ProRoute({ children }) {
  const [state, setState] = useState("checking"); // checking | pro | not-pro

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const data = await getProStatus();
        if (!cancelled) setState(data?.isPro ? "pro" : "not-pro");
      } catch (err) {
        if (!cancelled) setState("not-pro");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "checking") {
    // Wrapped in pro-page-wrap because that is where the Pro design tokens are
    // declared (they are scoped to it so they cannot leak into a free screen).
    // Without the wrapper the spinner renders with unresolved colours.
    return (
      <div className="pro-page-wrap">
        <div className="pro-loading-screen">
          <div className="pro-spinner" />
          <p>Checking your Pro membership…</p>
        </div>
      </div>
    );
  }

  if (state === "not-pro") {
    return <Navigate to="/theblogssphere-pro" replace />;
  }

  return children;
}

export default ProRoute;
